import { useApi } from '@/api';
import { CardList, LinkButton, ListSkeleton } from '@/components';
import {
  CurrencyValue,
  Flex,
  ListItem,
  WalletAddress
} from '@blockanalitica/ui';
import { Link } from 'react-router-dom';

export default function TopDepositors({ address, ...rest }) {
  const [data, error] = useApi({
    url: `/farms/${address}/depositors/`,
    queryParams: {
      p_size: '3',
      order: '-balance'
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <CardList
        title="Top Suppliers"
        action={
          <LinkButton to="suppliers" variant="secondary">
            view all
          </LinkButton>
        }
        {...rest}>
        {data['results'].length > 0 &&
          data['results'].map((row) => (
            <ListItem
              variant="link"
              // @ts-ignore
              as={Link}
              key={row.wallet_address}
              to={`suppliers/${row.wallet_address}`}>
              <Flex justifyContent="space-between" alignItems="center">
                <WalletAddress address={row.wallet_address} />
                <CurrencyValue
                  value={row.balance}
                  options={{
                    currency: {
                      name: row.staking_token_symbol,
                      address: row.staking_token_address
                    },
                    iconSize: '-1'
                  }}
                />
              </Flex>
            </ListItem>
          ))}
      </CardList>
    );
  }

  return <ListSkeleton {...rest} />;
}
